import React from "react"

type Props = {
  className?: string
}

const ShareIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.667 12.5v3.333c0 .921-.746 1.667-1.667 1.667H5c-.92 0-1.667-.746-1.667-1.667V12.5"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.667 6.667 10 3.333l3.333 3.334"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 3.333v9.167"
      />
    </svg>
  )
}

export default ShareIcon
